import { useQuery } from "@tanstack/react-query";

type OpAnalyticsPayload = {
  lastSavedAt: string;
  input: any;
  output: any;
  sourceTaxYear?: number | null;
} | null;

/**
 * Wraps the /api/op-analytics/latest query with staleTime: 0 and
 * exposes isFetching so callers can gate derived actuals on
 * `!isFetching`, preventing stale-data flashes.
 */
export function useOpAnalytics() {
  const { data, isFetching } = useQuery<OpAnalyticsPayload>({
    queryKey: ["/api/op-analytics/latest"],
    staleTime: 0,
  });
  return { data, isFetching };
}
